
import React from 'react';
import DreamRateStep from "../crystal-ball/DreamRateStep";
import ProjectDetailsStep from "../crystal-ball/ProjectDetailsStep";
import ExpensesStep from "../crystal-ball/ExpensesStep";
import TimeOffStep from "../crystal-ball/TimeOffStep";
import ResultsStep from "../crystal-ball/ResultsStep";
import { calculateCrystalBall } from "../crystal-ball/utils";
import type { CrystalBallFormData } from "../crystal-ball/types";

interface CrystalBallRendererProps {
  currentStep: number;
  formData: CrystalBallFormData;
  onInputChange: (field: string, value: string, category?: 'expenses' | 'timeOff') => void;
  onNext: () => void;
  onStartOver: () => void;
}

export const CrystalBallRenderer = ({
  currentStep,
  formData,
  onInputChange,
  onNext,
  onStartOver,
}: CrystalBallRendererProps) => {
  const calculations = calculateCrystalBall(formData);

  switch (currentStep) {
    case 1:
      return (
        <DreamRateStep
          formData={formData}
          onInputChange={onInputChange}
          onNext={onNext}
        />
      );
    case 2:
      return (
        <ProjectDetailsStep
          formData={formData}
          onInputChange={onInputChange}
          onNext={onNext}
        />
      );
    case 3:
      return (
        <ExpensesStep
          formData={formData}
          onInputChange={onInputChange}
          onNext={onNext}
        />
      );
    case 4:
      return (
        <TimeOffStep
          formData={formData}
          onInputChange={onInputChange}
          onNext={onNext}
        />
      );
    case 5:
      return (
        <ResultsStep
          calculations={calculations}
          onStartOver={onStartOver}
        />
      );
    default:
      return null;
  }
};
